import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Remove loading class
const root = document.getElementById('root');
root.classList.remove('wm-loading');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
